<template>
    <div v-if="mostrar" class="modal-mask" @click="fechar">
        <div class="jm margem modal-vincular-reuniao" @click.stop>
            <template v-if="etapa === 'pergunta'">
                <div class="modal-vincular-cabecalho">
                    <h2>Anexar relatório à reunião?</h2>
                    <p class="modal-vincular-subtitulo">
                        Não há reunião vinculada a este período. Deseja anexar o PDF do relatório a uma
                        reunião do Google Agenda?
                    </p>
                </div>

                <div class="submit direita modal-vincular-acoes">
                    <button type="button" class="acao-secundaria" @click="responderNao">
                        Não, apenas baixar o PDF
                    </button>
                    <button type="button" @click="etapa = 'url'">
                        Sim, informar URL da reunião
                    </button>
                </div>
            </template>

            <template v-else>
                <div class="modal-vincular-cabecalho">
                    <h2>URL da reunião no Google Agenda</h2>
                    <p class="modal-vincular-subtitulo">
                        Cole o link da reunião (ex.: "Ver na Agenda") para vincular e anexar o PDF.
                    </p>
                </div>

                <div class="grid-1">
                    <div>
                        <label for="vincular-url-reuniao">URL da reunião <span class="obrigatorio">*</span></label>
                        <input
                            id="vincular-url-reuniao"
                            v-model.trim="url"
                            type="url"
                            placeholder="https://calendar.google.com/..."
                            :disabled="loading"
                            @keydown.enter.prevent="confirmarVinculo"
                        />
                        <p class="modal-vincular-hint">
                            Use esta opção quando a reunião não foi criada pelo botão desta tela.
                        </p>
                        <p v-if="erro" class="modal-vincular-erro">{{ erro }}</p>
                    </div>
                </div>

                <div class="submit direita modal-vincular-acoes">
                    <button type="button" class="acao-secundaria" :disabled="loading" @click="etapa = 'pergunta'">
                        Voltar
                    </button>
                    <button type="button" class="acao-secundaria" :disabled="loading" @click="responderNao">
                        Não anexar
                    </button>
                    <button type="button" :disabled="loading || !urlValida" @click="confirmarVinculo">
                        {{ loading ? 'Vinculando…' : 'Vincular e anexar' }}
                    </button>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import serviceGoogleCalendar from '@/services/serviceGoogleCalendar'
import { salvarVinculoReuniao } from '@/utils/googleCalendarGestaoEntregas'

export default {
    name: 'ModalVincularReuniaoGoogle',

    props: {
        mostrar: {
            type: Boolean,
            default: false,
        },
        periodoInicio: {
            type: String,
            default: '',
        },
        periodoFim: {
            type: String,
            default: '',
        },
    },

    emits: ['fechar', 'vinculado', 'pular-anexo'],

    data() {
        return {
            etapa: 'pergunta',
            url: '',
            loading: false,
            erro: '',
        }
    },

    computed: {
        urlValida() {
            return Boolean(this.url && this.url.length >= 10)
        },
    },

    watch: {
        mostrar(valor) {
            if (valor) {
                this.etapa = 'pergunta'
                this.erro = ''
            } else {
                this.etapa = 'pergunta'
                this.url = ''
                this.loading = false
                this.erro = ''
            }
        },
    },

    methods: {
        fechar() {
            if (this.loading) return
            this.$emit('fechar')
        },

        responderNao() {
            this.$emit('pular-anexo')
        },

        async confirmarVinculo() {
            if (!this.urlValida || this.loading) return
            this.loading = true
            this.erro = ''
            try {
                const data = await serviceGoogleCalendar.resolverReuniaoPorUrl(this.url)
                const vinculo = salvarVinculoReuniao({
                    reuniaoGoogleId: data?.reuniao_google_id,
                    googleEventId: data?.google_event_id || null,
                    htmlLink: data?.html_link || this.url,
                    summary: data?.summary || null,
                    periodoInicio: this.periodoInicio,
                    periodoFim: this.periodoFim,
                    criadaPelaTela: false,
                })
                this.$emit('vinculado', {
                    ...vinculo,
                    summary: data?.summary || '',
                })
            } catch (error) {
                const mensagemApi = error?.response?.data?.message
                this.erro = mensagemApi || 'Não foi possível vincular a reunião com a URL informada.'
            } finally {
                this.loading = false
            }
        },
    },
}
</script>

<style scoped>
.modal-vincular-reuniao {
    width: min(42rem, 100%);
}

.modal-vincular-cabecalho h2 {
    margin-bottom: 0.35rem;
}

.modal-vincular-subtitulo {
    margin-top: 0;
    opacity: 0.8;
    font-size: 0.92rem;
}

.modal-vincular-hint {
    margin: 0.4rem 0 0;
    font-size: 0.82rem;
    opacity: 0.75;
}

.modal-vincular-erro {
    margin: 0.5rem 0 0;
    color: #c62828;
    font-size: 0.88rem;
    font-weight: 600;
}

.modal-vincular-acoes {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-top: 1rem;
}
</style>
